export type LocationBadge = { label: string; color: string; borderColor: string; bgColor: string };

type BadgeInput =
  | { source: 'vehicle'; cardType: 'delivery' | 'loading' }
  /**
   * 未割当も**地点ごと**にバッジを出す。詳細パネルが積地・降地を 2 ブロックで並べるため
   * (logposeTech/log_web_issues#315)。`side` は必須 —— 案件全体を指す「未割当」バッジは
   * その 2 ブロックに置き換わって出さなくなった。
   */
  | { source: 'unassigned'; side: 'loading' | 'unloading' };

/**
 * 詳細パネルに付ける地点種別バッジ。
 * サンプル (route-planner: components/dispatch/DispatchDetailPanel.tsx:355-362, 413-419) と同じ
 * 「降地=青 / 積地=橙」。色は 2 種を見分けるためのもので、共有しない。
 *
 * 未割当の地点バッジは**配車カードと同じ色**を使う。同じ画面に配車済みカードと未割当が
 * 並ぶので、未割当だけ別の色にすると読み替えが要る
 * （サンプルは積地=緑だが、本番の積地カードは橙なのでそちらへ揃える）。
 *
 * Why not 呼び出し側で alpha を足す: 色を `hsl(var(--x))` 形式に変えたとき、末尾の ')' を
 * 置換する書き方だと var() の閉じ括弧を壊す。薄色はここで組み立てる。
 *
 * null を返すのは入力が無いときだけ。**入力を渡した呼び出しは必ずバッジを得る**ことを
 * オーバーロードで表しておく（そうしないと、必ず値がある呼び出し側でも null ガードが要る
 * ように読め、扱いが不揃いになる。tsconfig を strict にしたときに効く）。
 */
export function resolveLocationBadge(input: BadgeInput): LocationBadge;
export function resolveLocationBadge(input: BadgeInput | null | undefined): LocationBadge | null;
export function resolveLocationBadge(input: BadgeInput | null | undefined): LocationBadge | null {
  if (!input) return null;
  const isUnloading = input.source === 'unassigned'
    ? input.side === 'unloading'
    : input.cardType === 'delivery';
  return isUnloading
    ? {
      label: '降地',
      color: 'hsl(210 80% 50%)',
      borderColor: 'hsl(210 80% 50% / 0.35)',
      bgColor: 'hsl(210 80% 50% / 0.14)',
    }
    : {
      label: '積地',
      color: 'hsl(30 90% 45%)',
      borderColor: 'hsl(30 90% 45% / 0.35)',
      bgColor: 'hsl(30 90% 45% / 0.14)',
    };
}
